import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Loader, Mail } from "lucide-react";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import CircleAvatar from "../../../../../atoms/CircleAvatar";
import { Typography } from "@mui/material";
import { useCookies } from "react-cookie";
import { decodeCookieValue, isValidBase64 } from "../../../../../../helpers/cookieHelper";
import InputLayout from "../../../../../atoms/InputLayout";
import Error from "../../../../../atoms/Error";
import CountryCodeDropdown from "../../../../../molecules/Dropdown/CountryCodeDropdown";
import { getData, patchData, postData } from "../../../../../../services";
import toast from "react-hot-toast";
import { confimationStyles } from "../../../../../../assets/styles/toast";
import CheckboxWrapper from "../../../../../atoms/CheckBoxWrapper/Checkbox";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  country_code: Yup.string(),
  get_notification: Yup.boolean(),
});

function Profile() {
  const [cookies, setCookie] = useCookies(["euid", "email","e_n", "role","eut" , "emp_id"]);
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    name: initialData?.name || "",
    email: initialData?.email || "",
    emp_id: initialData?.emp_id || "",
    country_code: initialData?.country_code || "+91",
    mobile: initialData?.mobile || "",
    get_notification: initialData?.get_notification || false,
  };

  const employeeInfo = async () => {
    try {
      const res = await getData({
        endpoint: "Employee/GetEmployeeById",
        params: {
          id: cookies.euid,
        },
        token: cookies.e_t,
      });

      if (res) {
        setInitialData(res?.data);
      }
    } catch (err) {
      // toast.error("Error Creating Employee", { style: errorStyles });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      const res = await patchData({
        endpoint: "Employee/EditEmployeeEntity",
        params: {
          employee_id: cookies.euid,
        },
        data: {
          name: values.name,
          country_code: values.country_code,
          mobile: values.mobile,
          get_notification: values.get_notification,
        },
        token: cookies.e_t,
      });

      if (res) {
        toast.success("Profile Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        setCookie("e_n", btoa(values.name), {
                  path: "/",
             });
      }
    } catch (err) {
      // toast.error("Error Creating Employee", { style: errorStyles });
    } finally {
      employeeInfo(); // Refresh the employee info after update
    }
  };

  useEffect(() => {
    employeeInfo();
    decodeCookieValue();
  }, []);

  if (loading) {
    return <div  className="d-flex justify-content-center align-center"><Loader /></div>;
  }

  return (
    <>
      <div className="d-flex flex-column " style={{ width: "60%" }}>
        <div className="d-flex gap-2 align-items-center cursor-pointer mt-2">
          <CircleAvatar
            name={decodeCookieValue(cookies.e_n)}
            size={40}
            fontSize="14px"
          />
          <div>
            <div style={{ fontWeight: 700 }}>
              {decodeCookieValue(cookies.e_n)}
            </div>
            <Typography variant="body2" color="black">
              {cookies.eml}
            </Typography>
          </div>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, errors, touched, isSubmitting }) => (
            <Form>
              <div className="row gx-4 mt-4">
                <InputLayout>
                  <label className="required-field">Employee Name</label>
                  <Field name="name" />
                  <Error error={errors.name} />
                </InputLayout>

                <InputLayout>
                  <label>Emp. ID</label>
                  <Field name="emp_id" disabled />
                </InputLayout>
              </div>

              <div className="row gx-4 mt-3 mb-4">
                <InputLayout>
                  <label className="required-field">Email</label>
                  <Field name="email" type="email" disabled />
                  <Error error={errors.email} />
                </InputLayout>

                <InputLayout>
                  <label>Phone Number</label>
                  <div className="d-flex gap-3">
                    <CountryCodeDropdown
                      selectedValue={values.country_code}
                      onChange={(code) => setFieldValue("country_code", code)}
                      isError={touched.country_code && !!errors.country_code}
                    />
                    <Field
                      type="text"
                      name="mobile"
                      className={`w-100 ${errors.mobile ? "error-input" : ""}`}
                      onChange={(e) => {
                        let numericInput = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        setFieldValue("mobile", numericInput);
                      }}
                    />
                  </div>
                  <Error error={errors.mobile} />
                </InputLayout>
              </div>

              <div className="row mt-4 mb-4">
                <div className={`checkbox_container`}>
                  <label htmlFor={`get_notification`}>Allow Email Notifications</label>
                  <CheckboxWrapper
                    type="checkbox"
                    id="get_notification"
                    name="get_notification"
                    value={values.get_notification}
                    checked={values.get_notification}
                    onChange={() => {
                      setFieldValue("get_notification", !values.get_notification);
                    }}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save changes"}
              </button>
            </Form>
          )}
        </Formik>
      </div>

      <hr
        className="my-3 border-2 border-solid"
        style={{ borderColor: "#D8DAE5" }}
      />
    </>
  );
}

export default Profile;



// import React, { useState, useEffect } from "react";
// import { Formik, Form, Field } from "formik";
// import { Loader, Mail } from "lucide-react";
// import * as Yup from "yup";
// import "bootstrap/dist/css/bootstrap.min.css";
// import CircleAvatar from "../../../../../atoms/CircleAvatar";
// import { Typography } from "@mui/material";
// import { useCookies } from "react-cookie";
// import { decodeCookieValue, isValidBase64 } from "../../../../../../helpers/cookieHelper";
// import InputLayout from "../../../../../atoms/InputLayout";
// import Error from "../../../../../atoms/Error";
// import CountryCodeDropdown from "../../../../../molecules/Dropdown/CountryCodeDropdown";
// import { getData, patchData, postData } from "../../../../../../services";
// import toast from "react-hot-toast";
// import { confimationStyles } from "../../../../../../assets/styles/toast";

// const validationSchema = Yup.object().shape({
//   name: Yup.string().required("Name is required"),
//   email: Yup.string().email("Invalid email").required("Email is required"),
//   country_code: Yup.string(),
// });

// function Profile() {
//   const [cookies, setCookie] = useCookies(["euid", "email","e_n", "role","eut" , "emp_id"]);
//   const [initialData, setInitialData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const initialValues = {
//     name: initialData?.name || "",
//     email: initialData?.email || "",
//     emp_id: initialData?.emp_id || "",
//     country_code: initialData?.country_code || "+91",
//     mobile: initialData?.mobile || "",
//   };

//   const employeeInfo = async () => {
//     try {
//       const res = await getData({
//         endpoint: "Employee/GetEmployeeById",
//         params: {
//           id: cookies.euid,
//         },
//         token: cookies.e_t,
//       });

//       if (res) {
//         setInitialData(res?.data);
//       }
//     } catch (err) {
//       // toast.error("Error Creating Employee", { style: errorStyles });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (values) => {
//     try {
//       const res = await patchData({
//         endpoint: "Employee/EditEmployeeEntity",
//         params: {
//           employee_id: cookies.euid,
//         },
//         data: {
//           name: values.name,
//           country_code: values.country_code,
//           mobile: values.mobile,
//         },
//         token: cookies.e_t,
//       });

//       if (res) {
//         toast.success("Profile Updated Successfully", {
//           style: confimationStyles,
//           duration: 1000,
//         });
//         setCookie("e_n", btoa(values.name), {
//                   path: "/",
//              });
//       }
//     } catch (err) {
//       // toast.error("Error Creating Employee", { style: errorStyles });
//     } finally {
//     }
//   };

//   useEffect(() => {
//     employeeInfo();
//     decodeCookieValue();
//   }, []);

//   if (loading) {
//     return <div  className="d-flex justify-content-center align-center"><Loader /></div>;
//   }


//   return (
//     <>
//       <div className="d-flex flex-column " style={{ width: "60%" }}>
//         <div className="d-flex gap-2 align-items-center cursor-pointer mt-2">
//           <CircleAvatar
//             name={decodeCookieValue(cookies.e_n)}
//             size={40}
//             fontSize="14px"
//           />
//           <div>
//             <div style={{ fontWeight: 700 }}>
//               {decodeCookieValue(cookies.e_n)}
//             </div>
//             <Typography variant="body2" color="black">
//               {cookies.eml}
//             </Typography>
//           </div>
//         </div>

//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//           enableReinitialize={true}
//         >
//           {({ values, setFieldValue, errors, touched, isSubmitting }) => (
//             <Form>
//               <div className="row gx-4 mt-4">
//                 <InputLayout>
//                   <label className="required-field">Employee Name</label>
//                   <Field name="name" />
//                   <Error error={errors.name} />
//                 </InputLayout>

//                 <InputLayout>
//                   <label>Emp. ID</label>
//                   <Field name="emp_id" disabled />
//                 </InputLayout>
//               </div>

//               <div className="row gx-4 mt-3 mb-4">
//                 <InputLayout>
//                   <label className="required-field">Email</label>
//                   <Field name="email" type="email" disabled />
//                   <Error error={errors.email} />
//                 </InputLayout>

//                 <InputLayout>
//                   <label>Phone Number</label>
//                   <div className="d-flex gap-3">
//                     <CountryCodeDropdown
//                       selectedValue={values.country_code}
//                       onChange={(code) => setFieldValue("country_code", code)}
//                       isError={touched.country_code && !!errors.country_code}
//                     />
//                     <Field
//                       type="text"
//                       name="mobile"
//                       className={`w-100 ${errors.mobile ? "error-input" : ""}`}
//                       onChange={(e) => {
//                         let numericInput = e.target.value.replace(
//                           /[^0-9]/g,
//                           ""
//                         );
//                         setFieldValue("mobile", numericInput);
//                       }}
//                     />
//                   </div>
//                   <Error error={errors.mobile} />
//                 </InputLayout>
//               </div>

//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "Saving..." : "Save changes"}
//               </button>
//             </Form>
//           )}
//         </Formik>
//       </div>

//       <hr
//         className="my-3 border-2 border-solid"
//         style={{ borderColor: "#D8DAE5" }}
//       />
//     </>
//   );
// }

// export default Profile;